/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_PriceInputs */

const en_price_page_app_price = /** @type {(inputs: Price_Page_App_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`49 zł`)
};

const pl_price_page_app_price = /** @type {(inputs: Price_Page_App_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`49 zł`)
};

/**
* | output |
* | --- |
* | "49 zł" |
*
* @param {Price_Page_App_PriceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_price = /** @type {((inputs?: Price_Page_App_PriceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_PriceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_price(inputs)
	return en_price_page_app_price(inputs)
});